export default "__VITE_ASSET__Dd3A4DRM__"